var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"slideshow-button"},[_c('svg',{staticClass:"slideshow-button__icon",attrs:{"viewBox":"0 0 100 100"}},[_c('path',{staticClass:"arrow",attrs:{"d":"M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }